import { initializeFBTracking } from '~/lib/tracking-fb';
import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    window.addEventListener('consentChanged', initializeFBTracking);
    initializeFBTracking();
  });
});
